module.exports = __webpack_public_path__ + "img/route-1.6d068c10.png";